/**
 * 整页跳转的两个小封装：测试里 jsdom 不支持真正的页面导航，mock 这个模块即可。
 */
export const navigateTo = (href) => {
    window.location.href = href;
};

export const replaceTo = (href) => {
    window.location.replace(href);
};
